import React from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import {
  ActionListItem,
  Box,
  Button,
  Icon,
  Box as Table,
  Box as TableBody,
} from '@node-space/ui-components'
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { BeneficiaryTransferDestination } from 'types/beneficiaries'

type TransferDestinationSelector = {
  onTransferDestinationClick: (value: string) => void
}

export const TransferDestinationSelector = ({
  onTransferDestinationClick,
}: TransferDestinationSelector) => {
  const { t } = useTranslation()
  const { accountCapabilities } = useAccountsContext()
  const action = useAtomValue(actionAtom)

  const { isUsdAchFedwireBeneficiaryCapabilityEnabled } = accountCapabilities || {}

  return (
    <Box>
      <Table tag="table" width="full" data-testid="contact-case-list">
        <TableBody tag="tbody" width="full">
          <ActionListItem
            key="local-beneficiary-selector"
            id="local-beneficiary-selector"
            title={t('manageBeneficiaries.local')}
            testId={'local-beneficiary-selector'}
            Avatar={
              <Button variant="ghost" iconElement={<Icon name={'MapPinCustom'} size="large" />} />
            }
            BodyPre={t(
              isUsdAchFedwireBeneficiaryCapabilityEnabled
                ? 'manageBeneficiaries.localTransferTypeDescriptionWithUSD'
                : 'manageBeneficiaries.localTransferTypeDescription'
            )}
            onItemClick={() => onTransferDestinationClick?.(BeneficiaryTransferDestination.LOCAL)}
          />
          <ActionListItem
            key="international-beneficiary-selector"
            id="international-beneficiary-selector"
            title={t('manageBeneficiaries.international')}
            testId={'international-beneficiary-selector'}
            Avatar={<Button variant="ghost" iconElement={<Icon name={'Globe'} size="large" />} />}
            BodyPost={t('manageBeneficiaries.internationalTransferTypeDescription')}
            onItemClick={() =>
              onTransferDestinationClick?.(BeneficiaryTransferDestination.INTERNATIONAL)
            }
          />
        </TableBody>
      </Table>
      <Box flex align="center" justify="center" paddingY={20}>
        <Button
          testId="cancel"
          variant="secondary"
          onClick={() => {
            action?.onClose()
          }}
        >
          {t('cancel')}
        </Button>
      </Box>
    </Box>
  )
}
